import { FC } from 'react';
import useMedia from 'react-use/lib/useMedia';
import { isMobileQuery, isTabletQuery } from '@higo/ui';
import { FloatingDiagnosisWindowDesktop } from './FloatingDiagnosisWindowDesktop';
import { FloatingDiagnosisWindowTablet } from './FloatingDiagnosisWindowTablet';
import { FloatingDiagnosisWindowProps } from './floatingDiagnosisWindowProps';
import { useActiveSection } from './useActiveSection';
import { ExaminationPageSectionId } from '@higo/common/src/features/ExaminationPage/models/examinationPageSectionId';

export const ExaminationPageFloatingDiagnosisWindow: FC<FloatingDiagnosisWindowProps> =
  (props) => {
    const isTabletView = useMedia(`${isTabletQuery}`);
    const isMobileView = useMedia(`${isMobileQuery}`);

    const activeSection = useActiveSection();

    if (isMobileView) {
      return null;
    } else if (isTabletView) {
      return <FloatingDiagnosisWindowTablet {...props} />;
    }

    return (
      <FloatingDiagnosisWindowDesktop
        isDesktopCollapsed={
          props.diagnosisModel.isNotAvailable ||
          ExaminationPageSectionId.Diagnosis === activeSection
        }
        {...props}
      />
    );
  };
